import { cn } from '@insta-club/utilities';
import { IconProps } from './icons-props';

function ReelVideoIcon({ className, width = 24, height = 24 }: IconProps) {
    return (
        <svg
            className={cn('text-gray-700', className)}
            width={width}
            height={height}
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path d='M14.7295 2H9.26953V6.36H14.7295V2Z' fill='currentColor' />
            <path d='M16.2305 2V6.36H21.8705C21.3605 3.61 19.3305 2.01 16.2305 2Z' fill='currentColor' />
            <path
                d='M2 7.85999V16.19C2 19.83 4.17 22 7.81 22H16.19C19.83 22 22 19.83 22 16.19V7.85999H2ZM14.44 16.18L12.36 17.38C11.92 17.63 11.49 17.76 11.09 17.76C10.79 17.76 10.52 17.69 10.27 17.55C9.69 17.22 9.37 16.54 9.37 15.66V13.26C9.37 12.38 9.69 11.7 10.27 11.37C10.85 11.03 11.59 11.09 12.36 11.54L14.44 12.74C15.21 13.18 15.63 13.8 15.63 14.47C15.63 15.14 15.2 15.73 14.44 16.18Z'
                fill='currentColor'
            />
            <path d='M7.76891 2C4.66891 2.01 2.63891 3.61 2.12891 6.36H7.76891V2Z' fill='currentColor' />
        </svg>
    );
}

export default ReelVideoIcon;

